import React from 'react';

function AddProfessionals({
    closeAddModal,
    contactSearchTerm,
    setContactSearchTerm,
    filteredContacts,
    toggleContactSelect,
    selectedContactIds,
    contacts,
    isAdding,
    handleAddProfessionals,
    message,
    error
}) {
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '10px 32px',
                    maxWidth: '600px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflow: 'hidden', // prevent double scrollbars
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Sticky Close Button */}
                <button
                    onClick={closeAddModal}
                    style={{
                        position: 'sticky',
                        background: 'rgba(0,0,0,0.07)',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        fontSize: '28px',
                        top: '5px',
                        right: '5px',
                        zIndex: 10,
                        alignSelf: 'flex-end',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#666',
                    }}
                >
                    ×
                </button>

                {/* Header */}
                <h2
                    style={{
                        margin: '0 0 24px 0',
                        textAlign: 'center',
                        color: 'black',
                        fontSize: "20px",
                        fontWeight: "bold"
                    }}
                >
                    Add Professionals
                </h2>

                {/* Search Input */}
                <input
                    placeholder="Search by name or email..."
                    value={contactSearchTerm}
                    onChange={(e) => {
                        // console.log("Search input → setting:", e.target.value);
                        setContactSearchTerm(e.target.value);
                    }}
                    style={{
                        width: '100%',
                        padding: '12px 16px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        marginBottom: '20px',
                        color: 'black',
                    }}
                />

                {/* Scrollable Contacts List */}
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        marginBottom: '24px',
                        paddingRight: '8px', // prevent scrollbar overlap
                    }}
                >
                    {filteredContacts.length > 0 ? (
                        filteredContacts.map((contact, index) => {
                            const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'N/A';

                            return (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '12px',
                                        borderBottom: '1px solid #eee',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => toggleContactSelect(contact.user_id)}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedContactIds.includes(contact.user_id)}
                                        onChange={() => { }}
                                        style={{ marginRight: '16px' }}
                                    />
                                    <div>
                                        <div style={{ fontWeight: 500, color: 'black' }}>{fullName}</div>
                                        <div style={{ fontSize: '14px', color: '#666' }}>{contact.email}</div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p style={{ textAlign: 'center', color: '#777' }}>No available contacts found.</p>
                    )}
                </div>

                {/* Sticky Footer */}
                <div
                    style={{
                        position: 'sticky',
                        bottom: '0',
                        background: 'white',
                        paddingTop: '16px',
                        borderTop: '1px solid #eee',
                        zIndex: 10,
                    }}
                >
                    {/* Selected Contacts */}
                    {selectedContactIds.length > 0 && (
                        <div style={{ marginBottom: '20px', maxHeight: "200px", overflow: "auto" }}>
                            <h4 style={{ marginBottom: '12px' }}>Selected ({selectedContactIds.length})</h4>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {selectedContactIds.map(id => {
                                    const contact = contacts.find(c => c.user_id === id);
                                    const name = contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() : id;

                                    return (
                                        <div
                                            key={id}
                                            style={{
                                                padding: '6px 12px',
                                                background: '#e0f2ff',
                                                borderRadius: '20px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                color: 'black',
                                            }}
                                        >
                                            {name}
                                            <button
                                                onClick={() => toggleContactSelect(id)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#c62828',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Buttons */}
                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                        <button
                            onClick={closeAddModal}
                            disabled={isAdding}
                            style={{
                                padding: '12px 28px',
                                background: '#f0f0f0',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                cursor: isAdding ? 'not-allowed' : 'pointer',
                                color: 'black',
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={handleAddProfessionals}
                            disabled={isAdding || selectedContactIds.length === 0}
                            style={{
                                padding: '12px 28px',
                                background: isAdding || selectedContactIds.length === 0 ? '#ccc' : '#1976d2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: isAdding || selectedContactIds.length === 0 ? 'not-allowed' : 'pointer',
                            }}
                        >
                            {isAdding ? 'Adding...' : 'Add Selected'}
                        </button>
                    </div>

                    {/* Messages */}
                    {message && (
                        <div style={{ marginTop: '20px', color: 'green', textAlign: 'center' }}>
                            {message}
                        </div>
                    )}
                    {error && (
                        <div style={{ marginTop: '20px', color: 'crimson', textAlign: 'center' }}>
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AddProfessionals;